import React from 'react';
import PropTypes from 'prop-types';
import { navigate } from 'gatsby';
import { useTranslation } from 'q3-ui-locale';
import {
  Button,
  Popover,
  Box,
  Paper,
  Badge,
  Grid,
  IconButton,
  Hidden,
} from '@material-ui/core';
import { Adapters, Builders } from 'q3-ui-forms';
// eslint-disable-next-line
import { useOpen } from 'useful-state';
import FilterListIcon from '@material-ui/icons/FilterList';
// eslint-disable-next-line
import { useQueryParams } from 'q3-ui-queryparams';
import { get, size } from 'lodash';
import ProductsFiltersLoader from './ProductsFiltersLoader';

const ProductsFilterLoaderAndForm = ({
  field,
  query,
  route,
  children,
  countFunction,
  icon: Icon,
}) => {
  const openState = useOpen();
  const { decode } = useQueryParams();
  const { t } = useTranslation('labels');

  const getLength = (xs) =>
    // eslint-disable-next-line
    Array.isArray(xs) ? size(xs) : xs ? 1 : 0;

  const count = () => {
    const decoded = decode(query);

    return countFunction
      ? countFunction(decoded)
      : getLength(get(decoded, field, []));
  };

  const renderForm = (options = []) => (
    <Adapters.EncodedUrl
      query={query}
      onSave={(newQuery) => {
        if (newQuery !== query) navigate(newQuery);

        openState.close();
      }}
    >
      {children && children(options)}
      {field && (
        <Builders.Field
          name={field}
          type="checkset"
          xl={6}
          lg={6}
          options={options}
          suppressLabel
        />
      )}
      <Box
        position="sticky"
        bottom={0}
        left={0}
        right={0}
        width="100%"
      >
        <Box bgcolor="background.paper" p={1}>
          <Grid alignItems="center" container spacing={1}>
            <Grid item>
              <Button
                color="secondary"
                variant="contained"
                type="submit"
              >
                Apply
              </Button>
            </Grid>
            <Grid item>
              <Button onClick={openState.close}>
                Cancel
              </Button>
            </Grid>
          </Grid>
        </Box>
      </Box>
    </Adapters.EncodedUrl>
  );

  return (
    <Box>
      <Badge badgeContent={count()} color="secondary">
        <Hidden mdDown>
          <Button
            color="inherit"
            onClick={openState.open}
            startIcon={<Icon />}
          >
            {t(route || 'attributes')}
          </Button>
        </Hidden>
        <Hidden lgUp>
          <IconButton
            color="inherit"
            aria-label={t(route || 'attributes')}
            onClick={openState.open}
          >
            <Icon />
          </IconButton>
        </Hidden>
      </Badge>
      <Popover
        anchorEl={openState.anchorEl}
        onClose={openState.close}
        open={openState.isOpen}
      >
        <Paper>
          <Box maxHeight={259} p={1} width={350}>
            {route ? (
              <ProductsFiltersLoader route={route}>
                {renderForm}
              </ProductsFiltersLoader>
            ) : (
              renderForm([])
            )}
          </Box>
        </Paper>
      </Popover>
    </Box>
  );
};

ProductsFilterLoaderAndForm.defaultProps = {
  children: null,
  countFunction: null,
  field: undefined,
  route: undefined,
  icon: FilterListIcon,
};

ProductsFilterLoaderAndForm.propTypes = {
  children: PropTypes.func,
  countFunction: PropTypes.func,
  field: PropTypes.string,
  query: PropTypes.string.isRequired,
  route: PropTypes.string,
  icon: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.element,
  ]),
};

export default ProductsFilterLoaderAndForm;
